import { Paper, Table, TableContainer } from "@mui/material"
import React from "react"

interface IValidationRuleTableContainer {
    children: React.ReactNode;
}

export const ValidationRuleTableContainer: React.FC<IValidationRuleTableContainer> = ({
    children
}) => {
    return (
        <TableContainer component={Paper} elevation={0} sx={{ 
            bgcolor: 'background.paper', 
            borderRadius: 0,
            border: '1px solid #e0e0e0'
        }}>
            <Table sx={{ minWidth: 650 }}>
                { children }
            </Table>
        </TableContainer>
    )
}